// app/localization/translations.js
// Локальные переводы приложения

export default {
  // Локальные переводы приложения
  app: {
    en: {
      navigation: {
        home: "Home",
        catalog: "Catalog", 
        rents: "My Rents",
        community: "Community",
        profile: "Profile"
      },
      footer: {
        year: "2025",
        heart: "❤",
        name: "Three Steps Studio Ltd",
        tagline: "Builded with love in"
      },
      community: {
        title: "News from Commune",
        loadmore: "Load More",
        finish: "Nothing more..."
      },
      comments: {
        title: "Comments",
        loginPrompt: "Please log in to leave a comment.",
        placeholder: "Enter your comment",
        send: "Send"
      },
      landing: {
        subscribeNewsletter: {
          title: "Stay Connected with Commune",
          subtitle: "Subscribe to our newsletter for exclusive events, special offers, and updates from Commune.",
          placeholder: "Please enter your email",
          action: "Subscribe"
        }
      },
      contacts: {
        title: "Get in Touch with Commune",
        instagram: "Stay connected with us by following Commune on Instagram:",
        instagramHandle: "@commune.phuket",
        name: "Commune – Terrace, Restaurant & Bar",
        addressLink: "https://goo.gl/maps/9u6voKo47HTcqriB9",
        streetAddress: "10/3 Laemsai Rd",
        addressLocality: "Karon",
        addressRegion: "Phuket",
        postalCode: "83100",
        telephone: "+66 93 232 6915",
        email: "hello{'@'}communephuket.com",
        seeOnGoogle: "See on Google Maps"
      },
      motto: {
        title: "Relax and Enjoy in Phuket's Most Stylish Bar and Terrace"
      },
      space: {
        offers: "Nightlife Experience",
        beautifulPlace: "Multiple DJ Zones & Premium Sound",
        partyVenueDescription: "Immerse yourself in Phuket's most vibrant nightlife venue featuring world-class DJ zones, blackroom with cutting-edge sound system, and unforgettable atmosphere",
        relaxedAtmosphereDescription: "From chill lounges to high-energy dance floors, we offer diverse zones to match your vibe",
        bookTheCommune: "Reserve Your Night",
        bookNow: "Book Now"
      }
    }
  }
};